import {IconButton, TextField, TextFieldProps} from '@mui/material'
import {DesktopDatePicker} from '@mui/x-date-pickers'
import CloseIcon from '@mui/icons-material/Close'

export interface DatePickerInputProps {
  label?: string
  inputFormat?: string
  value?: Date | null
  onChange: (value: Date | null) => void
  allowClear?: boolean
  error?: boolean
  helperText?: string
  fullWidth?: boolean
  onBlur?: TextFieldProps['onBlur']
  onFocus?: TextFieldProps['onFocus']
  id?: string
  shouldDisableDate?: (date: Date) => boolean
}

export const DatePickerInput = ({
  inputFormat,
  label,
  onChange,
  value,
  allowClear,
  shouldDisableDate,
  ...inputProps
}: DatePickerInputProps) => {
  return (
    <DesktopDatePicker
      label={label}
      inputFormat={inputFormat}
      value={value}
      onChange={onChange}
      shouldDisableDate={shouldDisableDate} 
      renderInput={(params) => (
        <TextField
          {...params}
          {...inputProps}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {allowClear && value && (
                  <IconButton onClick={() => onChange?.(null)}>
                    <CloseIcon />
                  </IconButton>
                )}
                {params.InputProps?.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )
}
